/* Shared by the homepage embed and the regular Alpine configurator. */
;(function () {
  if (window.SFConfigurator3D) return;

  function configurationUrl(base, code) {
    try {
      var target = new URL(base, window.location.origin);
      if (!/^https?:$/.test(target.protocol)) return '#';
      if (typeof code === 'string' && code.trim()) {
        target.searchParams.set('config', code);
      } else {
        target.searchParams.delete('config');
      }
      return target.href;
    } catch (_) {
      return '#';
    }
  }

  window.SFConfigurator3D = { url: configurationUrl };

  // Only update the external link: tracking parameters and the homepage URL
  // continue to belong to the shop. Delegation also works in the theme editor.
  document.addEventListener('sf-window-configurator-change', function (event) {
    var section = event.target && event.target.closest && event.target.closest('[data-sf-window-studio]');
    var link = section && section.querySelector('[data-sf-studio-open]');
    if (!link) return;
    link.href = configurationUrl(
      link.dataset.configuratorUrl,
      event.detail && event.detail.selection && event.detail.selection.code,
    );
  });
})();
